module.exports = __webpack_public_path__ + "assets/img/tiger3.0b778da4.jpg";